import { cn } from "@/lib/cn";

const TONE = {
    neutral: "bg-ink-muted/10 text-ink-muted",
    info: "bg-brand-soft text-brand",
    success: "bg-success/10 text-success",
    warning: "bg-warning/15 text-warning",
    danger: "bg-danger/10 text-danger",
} as const;

type Tone = keyof typeof TONE;

const LABELS: Record<string, { text: string; tone: Tone }> = {
    // Chiến dịch
    DRAFT: { text: "Nháp", tone: "neutral" },
    SCHEDULED: { text: "Đã hẹn lịch", tone: "info" },
    RUNNING: { text: "Đang gửi", tone: "info" },
    PAUSED: { text: "Tạm dừng", tone: "warning" },
    COMPLETED: { text: "Hoàn tất", tone: "success" },
    CANCELLED: { text: "Đã huỷ", tone: "neutral" },
    FAILED: { text: "Thất bại", tone: "danger" },
    // Bản ghi gửi
    PENDING: { text: "Chờ", tone: "neutral" },
    QUEUED: { text: "Trong hàng đợi", tone: "neutral" },
    SENDING: { text: "Đang gửi", tone: "info" },
    SENT: { text: "Đã gửi", tone: "success" },
    UNCERTAIN: { text: "Chưa rõ kết quả", tone: "warning" },
    SKIPPED: { text: "Bỏ qua", tone: "neutral" },
};

export function StatusBadge({ status, className }: { status: string; className?: string }) {
    const entry = LABELS[status] ?? { text: status, tone: "neutral" as Tone };

    return (
        <span
            className={cn(
                "inline-flex shrink-0 rounded-full px-2 py-0.5 text-xs font-medium",
                TONE[entry.tone],
                className,
            )}
        >
            {entry.text}
        </span>
    );
}
